import {EventAction} from '@ew/models';

export enum ToasterType {
  Success = 'success',
  Error = 'error',
  Warn = 'warning',
}

/**
 * Interface for the EwToaster service.
 */
export interface EwToaster {
  /**
   * Displays a toaster message with a specified type and optional action and configuration.
   *
   * @param message - The message to display in the toaster.
   * @param type - The type of toaster message (e.g., success, error, warning).
   * @param action - Optional action or event to trigger when the toaster is interacted with.
   * @param config - Optional configuration for the toaster, such as duration or styling options.
   */
  displayToast(
    message: string,
    type: ToasterType,
    action?: EventAction<any> | string,
    config?: any,
  ): void;

  observedToaster(): any;
}
